export const FOUNDATIONAL_ICONS: Record<string, string> = {
  'valuation.high': 'ValuationHigh',
  'valuation.low': 'ValuationLow',
  'valuation.improving': 'ValuationImproving',
  'valuation.deteriorating': 'ValuationDeteriorating',
  'analyst_estimates.strong': 'AnalystEstimatesStrong',
  'analyst_estimates.slow': 'AnalystEstimatesSlow',
  'analyst_estimates.improving': 'AnalystEstimatesImproving',
  'analyst_estimates.deteriorating': 'AnalystEstimatesDeteriorating',
  'analyst_ratings.optimistic': 'AnalystRatingsOptimistic',
  'analyst_ratings.pessimistic': 'AnalystRatingsPessimistic',
  'analyst_ratings.improving': 'AnalystRatingsImproving',
  'analyst_ratings.deteriorating': 'AnalystRatingsDeteriorating',
  'analyst_ratings.confident': 'AnalystRatingsConfident',
  'analyst_ratings.cautious': 'AnalystRatingsCautious',
  'dividend.high': 'DividendHigh',
  'dividend.low': 'DividendLow',
  'dividend.increasing': 'DividendIncreasing',
  'dividend.decreasing': 'DividendDecreasing',
  'earnings.beats': 'EarningsBeats',
  'earnings.misses': 'EarningsMisses',
};

export const TECHNICAL_ICONS: Record<string, string> = {
  'market_extremes.big_move_up': 'MarketExtremesBigMoveUp',
  'market_extremes.big_move_down': 'MarketExtremesBigMoveDown',
  'volatility.high': 'VolatilityHigh',
  'volatility.low': 'VolatilityLow',
  'volatility.increasing': 'VolatilityIncreasing',
  'volatility.decreasing': 'VolatilityDecreasing',
  'key_price_levels.near_resistance': 'KeyPriceLevelNearResistance',
  'key_price_levels.near_support': 'KeyPriceLevelNearSupport',
  'momentum_spikes.surge': 'MomentumSpikesSurge',
  'momentum_spikes.drop': 'MomentumSpikesDrop',
  'trend_analysis.strong_uptrend': 'TrendAnalysisStrongUptrend',
  'trend_analysis.strong_downtrend': 'TrendAnalysisStrongDowntrend',
  'momentum.strong_positive': 'MomentumStrongPositive',
  'momentum.strong_negative': 'MomentumStrongNegative',
  'momentum_reversals.bottoming': 'MomentumReversalsBottoming',
  'momentum_reversals.peaking': 'MomentumReversalsPeaking',
  'trading_volume.high': 'TradingVolumeHigh',
  'trading_volume.low': 'TradingVolumeLow',
  'trading_volume.increasing': 'TradingVolumeIncreasing',
  'trading_volume.decreasing': 'TradingVolumeDecreasing',
  'positioning.crowded_long': 'PositioningCrowdedLong',
  'positioning.crowded_short': 'PositioningCrowdedShort',
  'positioning.increased_long': 'PositioningIncreasedLong',
  'positioning.increased_short': 'PositioningIncreasedShort',
  'market_sentiment.optimistic': 'MarketSentimentOptimistic',
  'market_sentiment.pessimistic': 'MarketSentimentPessimistic',
  'market_sentiment.improving': 'MarketSentimentImproving',
  'market_sentiment.deteriorating': 'MarketSentimentDeteriorating',
  'seasonality.seasonality': '',
};

export const MACRO_ICONS: Record<string, string> = {
  'economic_growth.strong': 'EconomicGrowthStrong',
  'economic_growth.slow': 'EconomicGrowthSlow',
  'economic_growth.improving': 'EconomicGrowthImproving',
  'economic_growth.deteriorating': 'EconomicGrowthDeteriorating',
  'events.us_presidential_election': 'USPresidentialElection',
  'events.government_shutdown': 'GovernmentShutdown',
  'events.us_recession': 'USRecession',
  'events.earnings': '',
  'events.fomc_meeting': 'EventsFOMCMeeting',
  'events.opec_meeting': 'EventsOPECMeeting',
  'inflation.inflationary': 'InflationInflationary',
  'inflation.deflationary': 'InflationDeflationary',
  'inflation.inflation_watch': 'InflationInflationWatch',
  'inflation.deflation_watch': 'InflationDeflationWatch',
  'geopolitics.tense': 'GeopoliticsTense',
  'geopolitics.stable': 'GeopoliticsStable',
  'monetary_condition.easy': 'MonetaryConditionEasy',
  'monetary_condition.tight': 'MonetaryConditionTight',
  'economic_sentiment.optimistic': 'MarketSentimentOptimistic',
  'economic_sentiment.pessimistic': 'MarketSentimentPessimistic',
  'economic_sentiment.improving': 'MarketSentimentImproving',
  'economic_sentiment.deteriorating': 'MarketSentimentDeteriorating',
};

export const WATCHLIST_ID = 'watchlistId';
export const SCREENER_ID = 'screenerId';
export const INDEX_ID = 'indexId';
